import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const styles = {
  '& .social-proof-text': {
    color: colors.black
  },
  '& #social-proof-alt-title': {
    color: colors.primary
  },
  '& #social-proof-title': {
    color: colors.black
  },
  '& #social-proof-slot-title': {
    color: colors.black
  },
  '& #social-proof-slot-description': {
    color: colors.black
  },
  '& #social-proof-google-rating-text': {
    color: colors.black
  }
};

const socialProofStyles: any = (theme?: Theme) => styles;

export default socialProofStyles;